import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

const MainTitle = ({ title }) => {
  return <Typography variant="h5">{title}</Typography>;
};

MainTitle.propTypes = {};

export default MainTitle;
